import ViolationsSidePanel from './ViolationsSidePanel';

export default ViolationsSidePanel;
